import { Component } from '@angular/core';

@Component({
  selector: 'app-dredging-equipment-info',
  templateUrl: './dredging-equipment-info.component.html',
  styleUrls: ['./dredging-equipment-info.component.scss']
})
export class DredgingEquipmentInfoComponent {}
